// Extra choices for the "Add inbox › WhatsApp" provider picker (see channels/Whatsapp.vue)
export const UNOFFICIAL_PROVIDERS = ['baileys', 'zapi'];

export const unofficialProviderOptions = t => [
  {
    key: 'baileys',
    title: t('LOCO.WHATSAPP.PROVIDERS.BAILEYS'),
    description: t('LOCO.WHATSAPP.PROVIDERS.BAILEYS_DESC'),
    icon: 'i-lucide-qr-code',
  },
  {
    key: 'zapi',
    title: t('LOCO.WHATSAPP.PROVIDERS.ZAPI'),
    description: t('LOCO.WHATSAPP.PROVIDERS.ZAPI_DESC'),
    icon: 'i-lucide-plug-zap',
  },
];
